import { getRoute } from '@utils/route';

export const AUTH_ROUTE_URL = '/sign-in/*';
export const AUTH_MOBILE_NUMBER_PAGE_URL = '/sign-in';
export const AUTH_MEMBER_ID_PAGE_URL = '/sign-in/member-id';
export const AUTH_OTP_CODE_PAGE_URL = '/sign-in/otp-code/:mobileNumber';
export const AUTH_PASSWORD_PAGE_URL = '/sign-in/password/:mobileNumber';
export const AUTH_OTP_LINK_PAGE_URL = '/sign-in/otp-link/:otpToken';

export const routeAuthMobileNumberPage = () => getRoute(AUTH_MOBILE_NUMBER_PAGE_URL);
export const routeAuthMemberIdPage = () => getRoute(AUTH_MEMBER_ID_PAGE_URL);
export const routeAuthOtpCodePage = (routeParams: { mobileNumber: string }) => getRoute(AUTH_OTP_CODE_PAGE_URL, { routeParams });
export const routeAuthPasswordPage = (routeParams: { mobileNumber: string }) => getRoute(AUTH_PASSWORD_PAGE_URL, { routeParams });
